




































import { Component, Vue } from 'vue-property-decorator';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import TextField from '@/components/form/TextField.vue';
import { namespace } from 'vuex-class';
import Booking from '@/types/taxcard/Booking';

const BookingModule = namespace('booking');

@Component({
  components: {
    TextField,
    NewTranslation,
  },
})
export default class BillingAddressForm extends Vue {
  @BookingModule.Getter
  public currentBooking!: Booking;

  public firstname: string = '';

  public lastname: string = '';

  public email: string = '';

  public async created() {
    if (!this.currentBooking.isAnonymous) {
      const bIObject = this.currentBooking.bIObjects[0];
      this.firstname = bIObject.bIObjectData.firstName;
      this.lastname = bIObject.bIObjectData.lastName;
      this.email = bIObject.bIObjectData.email;

      this.updateData();
    }
  }

  private async updateData(): Promise<void> {
    const data = {
      firstname: this.firstname,
      lastname: this.lastname,
      email: this.email,
    };
    this.$emit('update-data', data);
  }
}
